import { useStore } from '@xyflow/react';
import { useMemo } from 'react';

import { StructureCanvasHelper } from '../canvas';
import type { Rect } from '../layout';

// Must be called inside <ReactFlowProvider>; reads the measured canvas size.
function useStructureCanvasViewport(bounds: Readonly<Rect>) {
  const width = useStore((s) => s.width);
  const height = useStore((s) => s.height);

  return useMemo(
    () =>
      StructureCanvasHelper.getTranslateExtent(bounds, {
        width,
        height,
      }),
    [bounds, width, height]
  );
}

export { useStructureCanvasViewport };
